package com.devi3east.bashbuddy.stripe

import com.devi3east.bashbuddy.features.common.util.UrlOpener
import kotlinx.browser.window
import org.w3c.dom.Window

class JsUrlOpener : UrlOpener {

    override var onRedirect: ((String) -> Unit)? = null

    override fun openUrl(url: String) {
        if (url.startsWith("/")) {
            window.history.pushState(null, "", url)
            onRedirect?.invoke(url)
        } else {
            window.location.href = url
        }
    }

    override fun replace(url: String) {
        if (url.startsWith("/")) {
            window.history.replaceState(null, "", url)
            onRedirect?.invoke(url)
        } else {
            window.location.href = url
        }
    }

    /*
    Commented out 5/3/26 @ 10:51 AM trying to fix browser back state.

    override var onRedirect: ((String) -> Unit)? = null

    override fun replace(url: String) {
        window.location.replace(url)
    }

    override fun openUrl(url: String) {
        window.location.href = url
    }*/

    /*override fun openUrl(url: String) {
        val popup: Window? = window.open(url, "_blank")

        if (popup != null) {
            // Declare interval ID first
            var interval: Int = 0

            interval = window.setInterval({
                try {
                    val href = popup.location.href
                    onRedirect?.invoke(href)
                    // Optionally close popup: popup.close()
                } catch (e: Throwable) {
                    // Cross-origin navigation may throw, ignore until redirect is readable
                }

                if (popup.closed) {
                    window.clearInterval(interval)
                }
            }, 500)
        }
    }*/
}